import React from "react";
import { SelectionContextPayload } from "../models/contexts/selection.context.models";

export const SelectionContext = React.createContext<SelectionContextPayload>({
  selectTag: () => {},
  selectCity: () => {},
  selectItinerary: () => {},
});
